import React from 'react'
import getHistory from "../../../store/getHistory"
import WithAuthentication from "../../shared/WithAuthentication"
import {extendUrlIPCC, extentUrlLogin} from "../../../store/getUrlLogin"
import {getAccessToken} from "../../../services/AuthServices"
import {LIST_MENU} from "../../shared/Contants"

function HomeContainer(props) {
    const {roles} = props
    const {location} = props.history
    const accessToken = getAccessToken()

    if (location.search !== '' || accessToken) {
        const history = getHistory()

        if (roles && roles?.length > 0) {
            const listLink = []

            // eslint-disable-next-line array-callback-return
            LIST_MENU.map(item => {
                const hasRole = roles.find(role => role.roleCode === item.role)

                if (hasRole) {
                    return listLink.push('/crm/' + item.link)
                }
            })

            setTimeout(() => {
                history.push(listLink[0])
            }, 500)
        } else {
            history.push('/crm')
        }
    } else {
        window.location.href = `${extentUrlLogin.url}?appCode=ipcc&service=${extendUrlIPCC.url}`
    }

    return (
        <div className="HomeContainer"/>
    )
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (props) {
    return (
        <WithAuthentication {...props}>
            {({isAuthenticated, user}) => {
                return (
                    <HomeContainer isAuthenticated={isAuthenticated} user={user} {...props}/>
                )
            }}
        </WithAuthentication>
    )
}
